export default "__VITE_ASSET__CJzmDned__"